/**
 * @import internal modules
 */

import Header from '@apps-shared/header/component';
import Helping from '@apps-widgets/helping/component';
import * as Utils from '@root-utils/index';
import * as URL from '@apps-enums/index';
/**
 * @import external modules
 */

import * as React from 'react';
import { pure } from 'recompose';
import { Link } from 'react-router-dom';

// component
const Component: React.FunctionComponent<any> = (props: any): any => {
    const {} = props;
    const [openModal, setOpenModal] = React.useState(false);

    const onClosehelping = (event: any) => setOpenModal(false);

    const onOpenModal = (event: any) => setOpenModal(true);

    const [date, setDate] = React.useState('00:00:00');

    React.useEffect(() => {
        const timerID = setInterval(() => tick(), 1000);

        return function cleanup() {
            clearInterval(timerID);
        };
    });

    function tick() {
        setDate(Utils.onClockUtils());
    }
    // data &&
    return (
        <div>
            {openModal && (
                <Helping helping={openModal} onClose={onClosehelping} />
            )}
            <div className="header-tollsense">
                <Header
                    {...props}
                    onOpenModal={onOpenModal}
                    timerShow={false}
                />
            </div>
            <div className="content-realtimes-delayed">
                <div className="content-transform">
                
                    <div className="left realtimes demo-cart">
                        <h2>REAL TIME</h2>
                        <span className="timers-demo">{date}</span>
                        <span className="restricted-demo">
                            Restricted lanes ( only for class 1 )
                        </span>
                        <div className="image-realtimes-delayed">
                            <div className="image-realtimes-icon">
                                <div className="image-realtimes-icon-text">
                                    <p className="realtime-icon-text-para">
                                        St.Isidore
                                    </p>
                                </div>
                                <svg
                                    width="15"
                                    height="20"
                                    viewBox="0 0 15 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M7.49798 0.00195312C3.36479 0.00195312 0 3.25195 0 7.24414C0 12.2012 6.70936 19.4785 6.9965 19.7832C7.26341 20.0723 7.73254 20.0723 7.99946 19.7832C8.2866 19.4746 14.996 12.2012 14.996 7.24414C15 3.25195 11.6352 0.00195312 7.49798 0.00195312ZM7.49798 10.8887C5.41925 10.8887 3.72472 9.25195 3.72472 7.24414C3.72472 5.23633 5.41925 3.59961 7.49798 3.59961C9.57671 3.59961 11.2712 5.23633 11.2712 7.24414C11.2712 9.25195 9.58075 10.8887 7.49798 10.8887Z"
                                        fill="url(#paint0_linear)"
                                    />
                                    <defs>
                                        <linearGradient
                                            id="paint0_linear"
                                            x1="7.49798"
                                            y1="0.00195312"
                                            x2="7.49798"
                                            y2="20"
                                            gradientUnits="userSpaceOnUse">
                                            <stop stop-color="#2575FC" />
                                            <stop
                                                offset="1"
                                                stop-color="#6A11CB"
                                            />
                                        </linearGradient>
                                    </defs>
                                </svg>
                            </div>
                        </div>
                        <Link to={{ pathname: URL.EnumUrl.REALTIME }}>
                            <div className="btn-realtimes-delayed btn-text">
                                GO!
                            </div>
                        </Link>
                    </div>


                    <div className="left delayed demo-cart">
                        <h2>DELAYED TIME</h2>

                        <div className="image-demo-delayed">
                            <div className="this-is-delayed">
                                <div className="small-bn">
                                    <div className="number-action">
                                        <span>1</span>
                                    </div>
                                    <h4>
                                        Pick some images in the photo libray
                                    </h4>
                                </div>
                               { false && <div className="small-change">or</div>}
                               { false && <div className="small-bn">
                                    <div className="number-action">
                                        <span>2</span>
                                    </div>
                                    <h4>Upload your data</h4>
                                </div>}
                            </div>
                        </div>
                        <Link to={{ pathname: URL.EnumUrl.DELAYED }}>
                            <div className="btn-realtimes-delayed btn-text">
                                GO!
                            </div>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default pure(Component);



// WEBPACK FOOTER //
// ./src/apps/components/@pages/demo/component.tsx